import {
    put,
    takeEvery,
    call,
    delay,
} from "redux-saga/effects"

import { Action } from "app/types/app-types"

import {
    exportTemplate as apiExportTemplate,
    getTemplateExport as apiGetTemplateExport,
    createProductsExport as apiCreateProductsExport,
    getProductsExport as apiGetProductsExport,
    getSimilarityExport as apiGetSimilarityExport,
    visualSimilarityCreateHashListAndPublish as apiVisualSimilarityCreateHashListAndPublish,
} from "app/helpers/api"

import {
    CREATE_PRODUCTS_EXPORT,
    CREATE_SIMILARITY_EXPORT,
    CREATE_TEMPLATE_EXPORT,
    GET_PRODUCTS_EXPORT,
    GET_SIMILARITY_EXPORT,
    GET_TEMPLATE_EXPORT
} from 'app/reducers/exports';

function* createTemplateExport(action) {
    const { templateIds, isAlt } = action.payload

    try {
        const { data } = yield call(apiExportTemplate, templateIds, isAlt)

        yield put({
            type: CREATE_TEMPLATE_EXPORT.SUCCESS,
            payload: {
                id: data.id,
            }
        })

        yield delay(5000)

        yield put({
            type: GET_TEMPLATE_EXPORT.CREATE,
            payload: {
                id: data.id,
            },
        })
    } catch (err) {
        yield put({
            type: CREATE_TEMPLATE_EXPORT.ERROR,
            error: err,
        })
    }
}

function* createProductsExport(action) {
    const { filters, viewtable } = action.payload

    try {
        const { data } = yield call(apiCreateProductsExport, filters, viewtable)

        yield put({
            type: CREATE_PRODUCTS_EXPORT.SUCCESS,
            payload: {
                id: data,
            }
        })

        yield delay(2500)

        yield put({
            type: GET_PRODUCTS_EXPORT.CREATE,
            payload: {
                id: data,
            },
        })
    } catch (err) {
        yield put({
            type: CREATE_PRODUCTS_EXPORT.ERROR,
            error: err,
        })
    }
}

function* createSimilarityExport(action) {
    const { templateId, templateIds, productId, nLimit, threshold, forcePriority } = action.payload

    try {
        const { data } = yield call(apiVisualSimilarityCreateHashListAndPublish, templateId, templateIds, productId, nLimit, threshold, forcePriority)

        yield put({
            type: CREATE_SIMILARITY_EXPORT.SUCCESS,
            payload: data
        })

        yield delay(2500)

        if (data?.id) {
            yield put({
                type: GET_SIMILARITY_EXPORT.CREATE,
                payload: data,
            })
        }
    } catch (err) {
        yield put({
            type: CREATE_SIMILARITY_EXPORT.ERROR,
            error: err,
        })
    }
}

function* getTemplateExport(action) {
    const { id } = action.payload
    try {
        const { data } = yield call(apiGetTemplateExport, id)
        yield put({
            type: GET_TEMPLATE_EXPORT.SUCCESS,
            payload: data,
        })
    } catch (err) {
        yield put({
            type: GET_TEMPLATE_EXPORT.ERROR,
            error: err,
        })
    }
}

function* getProductsExport(action) {
    const { id } = action.payload
    try {
        const { data } = yield call(apiGetProductsExport, id)
        yield put({
            type: GET_PRODUCTS_EXPORT.SUCCESS,
            payload: data,
        })
    } catch (err) {
        yield put({
            type: GET_PRODUCTS_EXPORT.ERROR,
            error: err,
        })
    }
}

function* getSimilarityExport(action) {
    const { id } = action.payload

    if (id) {
        try {
            const { data } = yield call(apiGetSimilarityExport, id)
            yield put({
                type: GET_SIMILARITY_EXPORT.SUCCESS,
                payload: data,
            })
        } catch (err) {
            yield put({
                type: GET_SIMILARITY_EXPORT.ERROR,
                error: err,
            })
        }
    } else {
        console.error('cannot create export in db', action.payload)
    }
}

export const watchCreateTemplateExport = function* () {
    yield takeEvery(CREATE_TEMPLATE_EXPORT.CREATE, createTemplateExport)
}

export const watchCreateProductsExport = function* () {
    yield takeEvery(CREATE_PRODUCTS_EXPORT.CREATE, createProductsExport)
}

export const watchCreateSimilarityExport = function* () {
    yield takeEvery(CREATE_SIMILARITY_EXPORT.CREATE, createSimilarityExport)
}

export const watchGetTemplateExport = function* () {
    yield takeEvery(GET_TEMPLATE_EXPORT.CREATE, getTemplateExport)
}

export const watchGetProductsExport = function* () {
    yield takeEvery(GET_PRODUCTS_EXPORT.CREATE, getProductsExport)
}

export const watchGetSimilarityExport = function* () {
    yield takeEvery(GET_SIMILARITY_EXPORT.CREATE, getSimilarityExport)
}